import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { IBookPreview, IPrice } from '@shared/jp/data/products';
import { TPhoto, INotice } from '@shared/common/data/products';
import { calculateDiscount } from '@shared/common/discount/utils';
import { EButtonColor } from '@studiobuki/web-core/lib/button';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent {
  @Input() photo!: TPhoto;

  @Input() caption!: IBookPreview['caption'];

  @Input() summary!: IBookPreview['summary'];

  @Input() notice!: INotice;

  @Input() price?: IPrice | undefined;

  @Input() alias!: string;

  @Input() discount?: string | undefined | null;

  @Input() buttonText?: string | undefined;

  @Input() buttonColor: keyof typeof EButtonColor = EButtonColor.accent;

  @Output() buttonClick = new EventEmitter<void>();

  public readonly calculateDiscount = calculateDiscount;

  // constructor() {}

  public onButtonClick(): void {
    this.buttonClick.emit();
  }
}
